const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const { Base64 } = require('js-base64');
const apiConfig = require('../../api-config');

function apiFactory({
  baseUrl,
  requestHandler,
}) {
  const headers = {
    'Content-Type': 'application/json',
  };
  const reqOpts = { headers, method: 'POST' };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    initializeTx(txType, metaData) {
      const url = getUrl('initializeTx');
      const inputs = txType.split("#@#");
      const reqOpts = {headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        txType: inputs[0],
        deviceCode: inputs[1],
        channel: inputs[2],
        branchCode: apiConfig.branchCode,
        portfolioId:parsedMetaData.portfolio.pfRelId,
        language: parsedMetaData.portfolio.language
      };
      
      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    
    generateTxChallenge(fieldObj,txType, metaData) {
      const url = getUrl('generateTxChallenge');
      const reqOpts = {headers, method: 'POST', json: true }
      const inputs = txType.split("#@#");
      const parsedMetaData = parseRequestMetaData(metaData);
      let dataFieldsObj = JSON.parse(Base64.decode(fieldObj))
      const txToken = inputs[3] ? inputs[3] : parsedMetaData.headers['Transaction-Token'];
      const paymentDigest = inputs[4] ? inputs[4] : '';
      const templateObj = inputs[5] ? JSON.parse(Base64.decode(inputs[5])) : null;
      const standingOrder = inputs[6] ? JSON.parse(Base64.decode(inputs[6])) : null;
      let body = {
        userId: parsedMetaData.qs.userId,
        txType: inputs[0],
        channel: inputs[2],
        language:parsedMetaData.portfolio.language,
        deviceCode:inputs[1],
        txToken: txToken,
        branchCode: apiConfig.branchCode,
        checksum: paymentDigest,
        userTemplate: templateObj,
        standingOrder,
      };

      dataFieldsObj = {
        ...dataFieldsObj,
        payReasonKey:+inputs[7] // payReasonKey type needs to be numeric, ensure adding unary operator
      }

      if(inputs[0] == 'internal-payments'){
        body['internalPaymentDetails'] =  dataFieldsObj;
      }else if(inputs[0] == 'international-payments'){
        body['internationalPaymentDetails'] =  dataFieldsObj;
      }else if(inputs[0] == 'sepa-payments'){
        body['sepaPaymentDetails'] =  dataFieldsObj;
      }else{
        body['domPaymentDetails'] =  dataFieldsObj;
      }

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    verifyChallengeResponse(details, metaData) {
      const url = getUrl('verifyChallengeResponse');
      const detail = details.split("#@@@#");
      const reqOpts = {headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const txToken = detail[3] ? detail[3] : parsedMetaData.headers['Transaction-Token'];
      const standingOrder = detail[5]? detail[5] == "true": false;
      const uuid = detail[7];   
      const modifiedTs= detail[8]; //WMCE-35439-Introducing uuid and modifiedTS for APT fix
      const body = {
        userId: parsedMetaData.qs.userId,
        txType: detail[0],
        channel: detail[1],
        deviceCode: detail[2],
        txToken: txToken,
        tdsSignature: detail[4],
        paymentDigest: detail[6],
        branchCode: apiConfig.branchCode,
        portfolioId: parsedMetaData.portfolio.pfRelId,
        language: parsedMetaData.portfolio.language,
        uuid: uuid,
        modifiedTs: modifiedTs,
        standingOrder
      };
      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },
  };
}

module.exports = apiFactory;